import { useState } from 'react';

export const useLocateProductTemplate = () => {
    const [selectedWarehouses, setSelectedWarehouses] = useState<string[]>([]);

    const onRemoveWarehouse = function (itemToRemove: string) {
        const newSelectedWarehouses = selectedWarehouses.filter(
            (value: string) => value !== itemToRemove
        );
        setSelectedWarehouses(newSelectedWarehouses);
    };

    const onApplyWarehouses = function (newSelectedWarehouses: string[]) {
        setSelectedWarehouses(newSelectedWarehouses);
    };

    const clearFilters = function () {
        setSelectedWarehouses([]);
    };

    return {
        selectedWarehouses,
        onRemoveWarehouse,
        onApplyWarehouses,
        clearFilters
    };
};
